import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {omit} from 'lodash';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation deleteLabelCategoryMutation($input: DeleteLabelCategoryInput!) {
		deleteLabelCategory(input: $input) {
			deletedLabelCategoryId
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: input.companyId,
			connectionKeys: [
				{
					key: 'Company_labelCategories',
				},
			],
			pathToConnection: ['company', 'labelCategories'],
			deletedIDFieldName: 'deletedLabelCategoryId',
		},
		{
			type: 'NODE_DELETE',
			deletedIDFieldName: 'deletedLabelCategoryId',
		},
	];
}

function getOptimisticResponse(input) {
	return {
		deleteLabelCategory: {
			deletedLabelCategoryId: input.id,
		},
	};
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Label Category Deleted');

	const cleanedInput = omit(input, ['companyId']);

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput}},
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
